module.exports = __webpack_public_path__ + "img/dps-anterior.90c3762d.svg";